import React from 'react'

import { useWebhook } from './_load/WebhookLoader'
import { useSaveWebhook } from './_requests/saveWebhook'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../../../packages/kiti/components/form/SubmitBar'
import Form from '../../../../../packages/kiti/components/form/form/Form'
import { useModalData } from '../../../../../components/modals/ModalsContext'
import SETTINGS from '../../../edit/widget/service/settings'
import { assoc, compose, pick, prop } from 'ramda'

const formatInitialData = form => {
  const payload = compose(
    pick(['reason', 'question']),
    item =>
      assoc(
        'question', //
        compose(
          pick(['name', 'id']), //
          item => assoc('id', prop('checklistId', form.payload), item), //
          item => assoc('name', prop('checklistName', form.payload), item)
        )(),
        item
      ),
    item =>
      assoc(
        'reason', //
        compose(
          pick(['name', 'id']), //
          item => assoc('id', prop('reasonId', form.payload), item), //
          item => assoc('name', prop('reasonName', form.payload), item)
        )(),
        item
      )
  )()

  return {
    ...form,
    payload
  }
}

const EditStaysWebhookForm = () => {
  const webhook = useWebhook()
  const { service } = useModalData()

  const [onSubmit, { loading, error }] = useSaveWebhook()

  const initialData = formatInitialData(webhook || SETTINGS[service])

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={initialData}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditStaysWebhookForm
